import { Link, NavLink, useLocation, useNavigate, useParams, useSearchParams, Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Enum from '../enum';
// import useSettings from '../../../hooks/useSettings';
// import useQueryString from '../../../utils/useQueryString';
import AgentComponent from './Agent';
import ClientComponent from './Client/index';
import NezamComponent from './Nezam/index';
import SocialComponent from './Social';
import ShowCaravansManagementLayout from './Layout';
import CaravansManagementShowMessage from './notifications';
import CaravansManagementShowBank from './Bank';

const ShowCaravansManagement = () => {
  const { t } = useTranslation();
  const queryParams = useParams();
  console.log({ queryParams });
  // const queryString = useQueryString();
  // const location = useLocation();
  // const { themeStretch } = useSettings();
  // const backUrl = `${Enum.routes.root(queryParams.type, queryParams.travel)}`;
  // const paramId = queryParams?.id;

  const Component = {
    [Enum.enumTab.object.client.value]: <ClientComponent />,
    [Enum.enumTab.object.agent.value]: <AgentComponent />,
    [Enum.enumTab.object.nezam.value]: <NezamComponent />,
    [Enum.enumTab.object.social.value]: <SocialComponent />,
    [Enum.enumTab.object.message.value]: <CaravansManagementShowMessage />,
    [Enum.enumTab.object.bank.value]: <CaravansManagementShowBank />,
  };

  return <>{Component[queryParams.tab] || <ShowCaravansManagementLayout />}</>;
  // <Routes>
  //   <Route path={`/:type`} element={<ShowCaravansManagement />} />
  // </Routes>
};

export default ShowCaravansManagement;
